// extracted by mini-css-extract-plugin
export default {"PercentBar":"PercentBar_PercentBar__ubyGV","Fill":"PercentBar_Fill__dHl0N","NoFill":"PercentBar_NoFill__wTRk3"};